module.exports = __webpack_public_path__ + "img/00027.fbdea934.webp";